import { isDebug } from './env'
import { getUserInfo, isSigned } from 'bxl-auth'
export const PARAM_SESSION_USER = 'x-session-user'
export const PARAM_SESSION_KEY = 'x-session-key'

export const PARAM_USER_ROLE = 'userRole'

// todo role 也应该改成 bxl-auth 的 api 获取
let envSuffix = isDebug() ? '_dogfood' : ''

export interface IUserSession {
  userId?: string | null
  sessionKey?: string | null
}

export interface IUserRole {
  capabilities: string[] | null | undefined
}

function keyOf(key: string): string {
  return key + envSuffix
}

function getUserId(): string {
  const info = getUserInfo()
  if (!info) return ''
  return info.userId || ''
}

function getUserName(): string | null | undefined {
    const info = getUserInfo()
    if (!info) return ''
    return info.userName || ''
}

function setRole(r: any) {
  if (r && Array.isArray(r.capabilities)) {
    try {
      localStorage.setItem(keyOf(PARAM_USER_ROLE), JSON.stringify(r))
    } catch (e) {
      console.error(e)
    }
  }
}

function getRole(): IUserRole | null | undefined {
  try {
    const rs = localStorage.getItem(keyOf(PARAM_USER_ROLE))
    if (!rs) return undefined
    return JSON.parse(rs)
  } catch (e) {
    console.error(e)
  }
  return null
}

export {
  getUserInfo,
  isSigned,
  getUserName,
  getUserId,
  setRole,
  getRole,
}
